<div class="container-fluid" id="mainContainer">

  <div class="headingRow">

    <div class="col-md-6" id="leftCol">
      <div class="Heading">
        Orders
      </div>

    </div>
    <div class="d-flex justify-content-between filtersContainer">

      <div class="col-md-2 filter-btn" appShowHide>
        <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapse"
          aria-expanded="false" aria-controls="collapseExample" (click)="loadFilters()">
          <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
            loading="lazy" style="margin: 0px 5px ;">
          Filters
        </button>
      </div>

      <div class="" [ngClass]="loggedUserRole === 4 ? 'col-md-12': 'col-md-10'">
        <div class="row">
          <div class="d-flex ">
            <div>
              <button (click)="getData()" [ngClass]="selectorActive === 1  ? 'active-all' : 'inactive-all'"
                (click)="selectorClicked(1)" type="submit">All</button>
            </div>
            <div>
              <button (click)="orderByStatus('CREATED')"
                [ngClass]="selectorActive === 2  ? 'active-middle' : 'inactive-middle'" (click)="selectorClicked(2)"
                type="submit">Created </button>
            </div>
            <div>
              <button (click)="orderByStatus('ACCEPTED')"
                [ngClass]="selectorActive === 3  ? 'active-middle' : 'inactive-middle'" (click)="selectorClicked(3)"
                type="submit">Accepted</button>
            </div>
            <div>
              <button (click)="orderByStatus('READY_FOR_PICKUP')"
                [ngClass]="selectorActive === 6  ? 'active-middle' : 'inactive-middle'" (click)="selectorClicked(6)"
                type="submit">Ready</button>
            </div>
            <div>
              <button (click)="orderByStatus('COMPLETED')"
                [ngClass]="selectorActive === 7  ? 'active-completed' : 'inactive-completed'"
                (click)="selectorClicked(7)" type="submit">Completed</button>
            </div>
            <div>
              <button (click)="orderByStatus('DENIED')"
                [ngClass]="selectorActive === 4  ? 'active-declined' : 'inactive-declined'" (click)="selectorClicked(4)"
                type="submit">Declined</button>
            </div>
            <div>
              <button (click)="orderByStatus('CANCELED')"
                [ngClass]="selectorActive === 5  ? 'active-cancled' : 'inactive-cancled'" (click)="selectorClicked(5)"
                type="submit" id="btn-month">Cancelled</button>
            </div>

          </div>
        </div>
      </div>

    </div>


    <div class="collapse" id="filterCollapse">
      <div class="filterCol">
        <form [formGroup]="filterForm" id="filterForm">
          <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
            <label class="filterLbl" for="menuName">Admin Filters</label>
            <div class="row filtersRow">
              <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                <label class="lblInput" for="menuName">Franchise</label>
                <div class="filterInput">
                  <select class='form-control bulkInput selectpicker' id="spicker_franchise"
                    (ngModelChange)="selectFranchise($event)" formControlName="franchise"
                    data-style="dropdownCustomStyle">
                    <option selected value='' disabled
                      data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                    <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                      {{franchise.name}} </option>
                  </select>
                </div>
              </div>
              <div>
                <label class="lblInput" for="menuName">Outlet</label>
                <div class="filterInput2">
                  <select class='form-control bulkInput selectpicker' id="spicker_shop" formControlName="shop"
                    (ngModelChange)="selectShop($event)" data-style="dropdownCustomStyle" disabled="!showShops">
                    <option selected value='' disabled
                      data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                    <option *ngFor="let shop of shops" [ngValue]="shop">
                      {{shop.name}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>


  </div>
  <div class="row " id="firstRow"></div>
  <div *ngIf="!isDataLoaded" class="item">
    <ngx-skeleton-loader class="skelton-tiles" count="1" [theme]="{ 
    'border-radius': '0px',
    height: '100px',
    'margin-top':'20px'
  }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="isDataLoaded">
    <app-table [isDataLoaded]="isDataLoaded" [tableData]="orders" [tableInfo]="tableInfo" [filterClickHeight]="45"
      [filterNotClickHeight]="64" [tableConfig]="tableConfig" [filterAvailability]="filterAvailability"
      [tableAction]="tableAction" [isFilterClicked]="isFilterClicked" [noItemsAvailable]="noItemsAvailable"
      [loggedUserRole]="loggedUserRole" (open)="open($event)" (searchItems)="searchOrders($event)"
      [placeholderText]="placeholderText" [filterSearchAvailability]="filterSearchAvailability" [policies]="[3]"
      (onViewClick)="onViewClick($event)" (getMoreItems)="getMoreOrders($event)" [currentPage]="currentPage"
      [pages]="pages" [visiblePages]="visiblePages">
    </app-table>
  </div>
</div>

<!-- View Modal -->
<div class="modal fade" id="viewDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" id="modal">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row modal-heading-row">
          <div class="row heading-row-right">
            <img src="../../../../../assets/icons/logo.png" width="35px" height="32px" class="d-inline-block align-top"
              alt="" loading="lazy" data-dismiss="modal">
            <div class="modal-Heading">
              Order Details
            </div>
          </div>
          <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px" style="cursor: pointer;"
            (click)="onCancel()" class="d-inline-block align-top" alt="" loading="lazy">
        </div>
        <hr>
        <div class="main-body" *ngIf='orderDetails'>
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col">
                  <div class="text-header">Order ID</div>
                  <div class="text-body-lg">#{{orderDetails.display_order_id}}</div>
                  <div *ngIf="orderDetails?.device_platform != null" class=" text-body-sm">
                    {{orderDetails?.device_platform == 'web' ? 'Web Order' : 'Mobile App Order'}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="col">
                  <div class="text-header">Platform</div>
                  <div class=" d-flex justify-content-start align-items-center">
                    <div class="platform">
                      <img src="{{orderDetails.platform_logo}}" width="44px" height="44px" style="cursor: pointer;"
                        class="d-inline-block align-top" alt="" loading="lazy">
                    </div>
                    <div class="text-body-lg pl-2">
                      {{orderDetails.platform}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-4">
            <div class="col-4">
              <div class="text-header">Customer Name</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.delivergate_customer != null ? orderDetails.delivergate_customer.first_name + " " +
                orderDetails.delivergate_customer.last_name : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Customer Code</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.contact_access_code != null ? orderDetails.contact_access_code : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Contact Number</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.delivergate_customer != null ? orderDetails.delivergate_customer.phone : '-'}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.delivery_type == 'Delivery'" class="row pt-3">
            <div class="col-4">
              <div class="text-header">Contact Address</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.delivergate_customer != null ? orderDetails.delivergate_customer.address : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Type</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.delivery_type}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Order Time</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.created_date_time}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Pickup Time</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.delivery_date_time}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Estimated Pickup Time (Mins)</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.arrive_in != 0 ? orderDetails.arrive_in : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Note</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.note != '' ? orderDetails.note : '-'}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.table_name  != ''" class="row pt-3">
            <div class="col-4">
              <div class="text-header">Table</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.table_name != '' ? orderDetails.table_name : '-'}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.table_order_method  != ''" class="row pt-3">
            <div class="col-4">
              <div class="text-header">Table Order Method</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.table_order_method != '' ? orderDetails.table_order_method : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Subtotal</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' + orderDetails.sub_total}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.shopFee?.length > 0">
            <div class="row pt-3" *ngFor="let fee of orderDetails.shopFee  let id = index;">
              <div class="col-4">
                <div class="text-header">{{fee.name}}</div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{currency + ' ' + fee.amount}}
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Discount</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' +orderDetails.discount}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Reward Discount</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' +orderDetails.loyalty?.redeemed_amount /100}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.tip != '0.00'" class="row pt-3">
            <div class="col-4">
              <div class="text-header">Tip</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' +orderDetails.tip}} ( {{orderDetails.tip_percentage}} )
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header"> {{orderDetails.platform}}
                charges</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' + orderDetails.total_fee}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.shipping_total != '0.00'" class="row pt-3">
            <div class="col-4">
              <div class="text-header">
                Delivery charges</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.shipping_total != null ? currency + ' ' + orderDetails.shipping_total : '-'}}
              </div>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">
              <div class="text-header">Total</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{currency + ' ' +orderDetails.total_amount}}
              </div>
            </div>
          </div>

          <div *ngIf="orderDetails.payment_status != null" class="row pt-3">
            <div class="col-4">
              <div class="text-header">Payment Status</div>
            </div>
            <div class="col">
              <div class="text-body-sm pl-2">
                {{orderDetails.payment_status}}
              </div>
            </div>
          </div>
          <div *ngIf="orderDetails.deliveries.length > 0">
            <div class="text-body-md font-weight-bold pt-4">
              <hr>
              Driver Details
            </div>
            <div class="row pt-3">
              <div class="col-4">
                <div class="text-header"> Driver Name
                </div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{orderDetails.deliveries[0].first_name != null ? orderDetails.deliveries[0].first_name + " " : ''}}
                  {{orderDetails.deliveries[0].last_name ? orderDetails.deliveries[0].last_name : '' }}
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-4">
                <div class="text-header"> Driver Contact No
                </div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{orderDetails.deliveries[0].contact_no}}
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-4">
                <div class="text-header"> Driver Contact Code
                </div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{orderDetails.deliveries[0].phone_code}}
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-4">
                <div class="text-header"> Arrive in Time
                </div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{orderDetails.deliveries[0].arrive_in != 0 ? orderDetails.deliveries[0].arrive_in : '-'}}
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-4">
                <div class="text-header"> Driver Status
                </div>
              </div>
              <div class="col">
                <div class="text-body-sm pl-2">
                  {{orderDetails.deliveries[0].status}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="delayModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" id="modal">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row modal-heading-row">
          <div class="row heading-row-right">
            <img src="../../../../../assets/icons/logo.png" width="35px" height="32px" class="d-inline-block align-top"
              alt="" loading="lazy" data-dismiss="modal">
            <div class="modal-Heading">
              Delay Order
            </div>
          </div>
          <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px" style="cursor: pointer;"
            class="d-inline-block align-top" alt="" loading="lazy" (click)="onCancelDelayModal()">
        </div>
        <hr>
        <p *ngIf="message != ''  && !isSuccess" class="alert alert-danger">{{message}}</p>
        <p *ngIf="message != ''   && isSuccess" class="alert alert-success">{{message}}</p>

        <div>
          <div [formGroup]="delayForm">
            <div class="input-full">
              <div class="form-group">
                <label for="exampleInputEmail1" class="lblInput">Delay For(Minutes)</label><span
                  style="color: red;">*</span>
                <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect3"
                  formControlName="time" [ngClass]="{ 'is-invalid': submitted && delayForm.controls.time.errors }">
                  <option value='' selected>Choose a time...</option>
                  <option *ngFor="let time of delayTimes" [ngValue]="time">
                    {{time.timeZone}}
                  </option>
                </select>
                <div *ngIf="submitted && delayForm.controls.time.errors" class="invalid-feedback">
                  <div *ngIf="delayForm.controls.time.errors.required">Please select a time</div>
                </div>
              </div>
            </div>

          </div>


          <div style="display: flex; justify-content: space-between; margin : 0px;">
            <div (click)="onCancelDelayModal()" class="btn-cancel"
              style=" display: flex; justify-content: center; align-items: center; cursor: pointer;">
              Cancel
            </div>

            <button (click)="onDelayClicked()" [disabled]="isSuccess ? true : false" class="btn-avalibility">
              <span *ngIf="!isActionClick">Delay</span>
              <div *ngIf="isActionClick" style="position: relative; ">
                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#fff" type="ball-clip-rotate"
                  [fullScreen]="false"></ngx-spinner>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>